export default "__VITE_ASSET__$YOq17HX__"